import $ from 'jquery';

/**
 * Hiding the outer form wrapper on load on event reg form and removing this if block has content.
 */
class FormWrapper {
    constructor() {
        this.hiddenContainer = $('.js-tickets-containers, .js-optional-extras-containers, .js-payment-method-container');
        this.formWrapper = $('.js-hidden-field');

        // Show Extra Delegates that are not empty on load
        $(window).on('load', () => {
            this.hiddenContainer.each(function () {
                if ($(this).html().trim().length) {
                    $(this).parent(this.formWrapper).removeClass('is-hidden');
                }
            });
        });
    }
}

export default FormWrapper;
